"use client"

import { useMemo } from "react"
import { paymentMethodLabel } from "src/checkout/components/stages/paymentForm/constants"
import { useSupportedPaymentMethods } from "src/checkout/components/stages/paymentForm/useSupportedPaymentMethods"
import { ProviderIcons } from "src/components/styled/ProviderIcons"
import { TooltipProps } from "src/components/styled/Tooltip"
import { PaymentIcon, PaymentIconName } from "src/components/unstyled/PaymentIcon"
import { WCStorePaymentMethod } from "src/data/woocommerce/wcStoreTypes"

const paymentMethods: { icon: PaymentIconName; name: string; id: WCStorePaymentMethod }[] = [
  { icon: "paypal", name: paymentMethodLabel.mollie_wc_gateway_paypal, id: "mollie_wc_gateway_paypal" },
  { icon: "klarna", name: paymentMethodLabel.mollie_wc_gateway_klarna, id: "mollie_wc_gateway_klarna" },
  { icon: "mastercard", name: "Mastercard", id: "mollie_wc_gateway_creditcard" },
  { icon: "visa", name: "Visa", id: "mollie_wc_gateway_creditcard" },
  { icon: "sepa", name: paymentMethodLabel.mollie_wc_gateway_banktransfer, id: "mollie_wc_gateway_banktransfer" },
]

export type PaymentMethodsProps = {
  height: "lg" | "md" | "sm"
  tooltipVariant?: TooltipProps["variant"]
}

export const PaymentMethodIcons = ({ height, tooltipVariant }: PaymentMethodsProps) => {
  const supportedPaymentMethods = useSupportedPaymentMethods()

  const items = useMemo(() => {
    return paymentMethods.filter((method) => supportedPaymentMethods.includes(method.id))
  }, [supportedPaymentMethods])

  return (
    <ProviderIcons
      Icon={PaymentIcon}
      items={items}
      height={height}
      tooltipVariant={tooltipVariant}
      className="aspect-[4/3]"
    />
  )
}
